<div class="card border-0 shadow-sm" style="background-color: #f9fafb">
  <div class="card-body d-flex flex-column justify-content-between py-2">
    <div>
      <h5 class="card-title mb-2">{{ titleCard }}</h5>

      @if (isLoading) {
        <div class="text-center py-3">
          <output class="spinner-border spinner-border-sm text-primary">
            <span class="visually-hidden">Carregando...</span>
          </output>
          <p class="text-muted small mt-2 mb-0">Carregando dados...</p>
        </div>
      } @else {
        <h5 class="card-title mb-2 fw-bold" [ngClass]="valueColorClass">
          {{ value }}
        </h5>
        @if (description) {
          <h6 class="card-text text-muted">
            {{ description }}
          </h6>
        }
      }
    </div>

    @if (buttonLabel && buttonRoute) {
      <div class="mt-3">
        <app-action-button
          [label]="buttonLabel"
          [variant]="buttonVariant"
          [route]="buttonRoute"
        >
        </app-action-button>
      </div>
    }
  </div>
</div>
